import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import FleetPage from "./pages/FleetPage";
import DestinationsPage from "./pages/DestinationsPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/services/*" element={<HomePage />} />
          <Route path="/solutions/*" element={<HomePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
